(function () {

  'use strict';

  eclipseApp

    .controller('prepaidRefillAutoPayPlanCtrl', ['$scope', '$rootScope', '$state', 'uteModal', 'uteLocale', '$http', '$filter', '$window', 'httpService', 'uteSemafoneService', 'util', 'prepaidRefillAutoPayPlanService', 'prepaidRegisteredCCInfoService', 'prepaidPlanInfoService', 'prepaidRefillTaxCalculationService', 'prepaidUserInfoService', 'prepaidAutoRefillInfoService', 'retrievePrepaidPlanInfo', 'retrievePrepaidUserInfo', '$sessionStorage', function ($scope, $rootScope, $state, uteModal, uteLocale, $http, $filter, $window, httpService, uteSemafoneService, util, prepaidRefillAutoPayPlanService, prepaidRegisteredCCInfoService, prepaidPlanInfoService, prepaidRefillTaxCalculationService, prepaidUserInfoService, prepaidAutoRefillInfoService, retrievePrepaidPlanInfo, retrievePrepaidUserInfo, $sessionStorage) {

      $scope.$extend({
        init: function () {

          console.log('prepaidRefillAutoPayPlanCtrl');

          $scope.language = uteLocale.language;
          $scope.isAutoPayReview = true;

          $scope.stopAutoPaymentNotifier = '';
          prepaidAutoRefillInfoService.setStopAutoPaymentResponse('');
          $scope.flag = prepaidAutoRefillInfoService.getAutoPayPlanInfo().registeredFlag;
          $scope.CreditCardRegistrationStatus = prepaidRegisteredCCInfoService.getCreditCardRegistrationStatus();
          $scope.planTitle = prepaidPlanInfoService.getAirTimePlanTitle();
          $scope.planFeatures = prepaidPlanInfoService.getAirTimePlanFeatures();
          $scope.planFee = prepaidPlanInfoService.getAirTimePlanFee();
          $scope.cycleDate = prepaidPlanInfoService.getAirTimePlanBillingCycleDate();
          $scope.ctn = prepaidUserInfoService.getCTN();
          $scope.email = prepaidUserInfoService.getEmailAddress();
          $scope.rechargeDate = prepaidAutoRefillInfoService.getAutoPayPlanInfo().rechargeDate;
          $scope.recDate = new Date($scope.rechargeDate);
          $scope.autoSubscriptionInfo = prepaidPlanInfoService.getAutoSubscriptionInfo();
          $scope.name = prepaidUserInfoService.getFirstName() + ' ' + prepaidUserInfoService.getLastName();
          $scope.expiryDate = prepaidRegisteredCCInfoService.getMonth();
          $scope.cardNumber = prepaidRegisteredCCInfoService.getTokenizedCCNumber();
          $scope.autoRefillSubscribed = 'true';
          $scope.billingAddress = prepaidUserInfoService.getBillingAddress();
          $scope.$storage = $sessionStorage;

          if(prepaidUserInfoService.getCTN() === null || prepaidUserInfoService.getCTN() === '' || prepaidUserInfoService.getBAN() === null || prepaidUserInfoService.getBAN() === '') {
            prepaidUserInfoService.setCTN($scope.$storage.selectedCTN);
            prepaidUserInfoService.setBAN($scope.$storage.selectedBAN);
            $scope.ctn = prepaidUserInfoService.getCTN();
          }
        },
        backToAccount: function () {
          $state.go('myAccount.overview');
        },
        fetchRefillBalance: function () {
          var promise = httpService.send('v1/refill/autorefill/submit/autopayment', {
            accountNumber: prepaidUserInfoService.getBAN(),
            ctn: prepaidUserInfoService.getCTN(),
            autoMSFEligibility: true,
            autoEXLBEligibility: false,
            //autoMSFEligibility: prepaidAutoRefillInfoService.getAutoPayPlanEligibility(),
            refillAmount: prepaidPlanInfoService.getAirTimePlanFee()
          });
          promise.then(
            function (item) {
              if (item.data.error || item.data.status == 'Failed') {
                $scope.submitRefillBalanceError = true;
              } else {
                $scope.isAutoPayReview = false;
                $window.scrollTo(0,0);
              }
            },
            function (reason) {
              $scope.autoPayPlanError = true;
            }
          );
        },
        updateRefillBalanceService: function () {
          var promise = httpService.send(
            'v1/refill/autorefill/scheduled/details', // TODO : Need to change
            {
              accountNumber: prepaidUserInfoService.getBAN(),
              ctn: prepaidUserInfoService.getCTN(),
              language: $scope.language
            });
          promise.then(
            function (result) {
              if (result.data.error || result.data.error != '') {
                $scope.autoRefillSubscriptionInfoError = true;
                console.log('AutoRefillSubscriptionInfo Error');
              } else {
                console.log('Got AutoRefillSubscriptionInfo Successfully');
                $scope.autoRefillSubscriptionInfo = result.data;
                console.log('$scope.autoRefillSubscriptionInfo :: ' + $scope.autoRefillSubscriptionInfo);
                prepaidAutoRefillInfoService.setAutoPayPlanInfo($scope.autoRefillSubscriptionInfo.autoPayPlan);
                prepaidAutoRefillInfoService.setAutoRefillBalanceInfo($scope.autoRefillSubscriptionInfo.autoRefillBalance);
                var $translate = $filter('translate');
                var $currency = $filter('currency');
                if (prepaidAutoRefillInfoService.getAutoPayPlanInfo().registeredFlag) {
                  var $date = $filter('date');
                  var scheduledRefillDate = new Date($scope.autoRefillSubscriptionInfo.autoPayPlan.rechargeDate);
                  $scope.autoRefillSubscriptionInfo.autoPayPlan.rechargeDate = scheduledRefillDate;
                  prepaidAutoRefillInfoService.setAutoPayPlanSubContent('<p class="fido-tick-icon">' + $translate('global.label.nextPaymentOf') + ' ' + $currency(prepaidAutoRefillInfoService.getAutoPayPlanInfo().rechargeAmount) + '</p><p>' + $translate('global.label.autoPayPlanBridge') + ' ' + $date(scheduledRefillDate, 'MMMM dd, yyyy') + '</p>');
                  prepaidAutoRefillInfoService.setAutoPayPlanContentClass('tab pp-refill-margin-top-1-5 pp-refill-padding-top-0-2');
                  if (prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().registeredFlag) {
                    prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent('<p class="fido-tick-icon-secondary">' + $translate('global.label.add') + ' ' + $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().rechargeAmount) + ' ' + $translate('global.label.autoRefillBalanceBridge') + ' ' + $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().balanceThreshold) + '</p>');
                    prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass('tab pp-refill-margin-top-1-5 pp-refill-padding-top-0-9');
                  } else {
                    prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent('');
                    prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass('tab pp-refill-margin-top-1-5');
                  }
                } else {
                  prepaidAutoRefillInfoService.setAutoPayPlanSubContent('');
                  prepaidAutoRefillInfoService.setAutoPayPlanContentClass('tab pp-refill-margin-top-1-5');
                  if (prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().registeredFlag) {
                    prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent('<p class="fido-tick-icon-secondary">' + $translate('global.label.add') + ' ' + $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().rechargeAmount) + ' ' + $translate('global.label.autoRefillBalanceBridge') + ' ' + $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().balanceThreshold) + '</p>');
                    prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass('tab pp-refill-margin-top-1-5 pp-refill-padding-top-0-9');
                  } else {
                    prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent('');
                    prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass('tab pp-refill-margin-top-1-5');
                  }
                }
                prepaidAutoRefillInfoService.setStopAutoPaymentResponse(true);
                $state.go('myAccount.prepaidRefill');
              }
            },
            function (reason) {
              $scope.autoRefillSubscriptionInfoError = true;
            }
          );
        },
        getAddonListInfo: function (accountNumber, subscriberNumber, language) {
          var promise = httpService.send(
            'v1/wireless/prepaid/dashboard/addOn', // TODO : Need to change
            {
              accountNumber: accountNumber,
              ctn: subscriberNumber,
              language: language
            });

          promise.then(
            function (result) {
              if (result.data.error || result.data.status == 'Failed') {
                $scope.addonListInfoError = true;
              } else {
                var addonListInfo = result.data;
                var masterAddonList;
                if (addonListInfo != null) {
                  if (addonListInfo.addonDetailList != null) {
                    masterAddonList = addonListInfo.addonDetailList;
                    if (addonListInfo.addOnJsonList != null) {
                      _.each(addonListInfo.addOnJsonList, function (addOnJsonInfo) {
                        _.each(addonListInfo.addonDetailList, function (addonDetailInfo) {
                          if (addOnJsonInfo.productId == addonDetailInfo.productCode) {
                            addonDetailInfo.contentInfo = addOnJsonInfo;
                            var taxPromise = httpService.send('v1/refill/autorefill/tax/amount', {
                              accountNumber: accountNumber,
                              ctn: subscriberNumber,
                              refillAmount: addonDetailInfo.amount
                            });
                            taxPromise.then(
                              function (detail) {
                                if (detail.data.error || detail.data.status == 'Failed') {
                                  $scope.prepaidRefillAddonInfoError = true;
                                } else {
                                  addonDetailInfo.taxInfo = detail.data;
                                }
                              },
                              function (reason) {
                                $scope.prepaidRefillAddonInfoError = true;
                              }
                            );
                          }
                        });
                      });
                      masterAddonList = addonListInfo.addonDetailList;
                    }
                  } else {
                    if (addonListInfo.addOnJsonList != null) {
                      masterAddonList = addonListInfo.addOnJsonList;
                    } else {
                      $scope.addonListInfoError = true;
                    }
                  }
                } else {
                  $scope.addonListInfoError = true;
                }
                $scope.masterAddonListInfo = masterAddonList;
                console.log('$scope.masterAddonListInfo :: ' + $scope.masterAddonListInfo);
              }
            },
            function (reason) {
              $scope.addonListInfoError = true;
            }
          );
        },
        cancel: function () {
          //$scope.clearSharedPropertyService();
          $state.go('myAccount.prepaidWLDashboard', { 'accountNumber': prepaidUserInfoService.getBAN(), 'subscriberNo': prepaidUserInfoService.getCTN() });
        },
        continueButton: function () {
          var promise = httpService.send('v1/refill/autorefill/tax/amount', {
            accountNumber: prepaidUserInfoService.getBAN(),
            ctn: prepaidUserInfoService.getCTN(),
            refillAmount: prepaidPlanInfoService.getAirTimePlanFee()
          });
          promise.then(
            function (detail) {
              if (detail.data.error || detail.data.status == 'Failed') {
                $scope.prepaidRefillAutoPayPlanError = true;
              } else {
                prepaidRefillTaxCalculationService.setGST(detail.data.gst);
                prepaidRefillTaxCalculationService.setPST(detail.data.pst);
                prepaidRefillTaxCalculationService.setTotal(detail.data.totalAmount);
                $state.go('myAccount.prepaidRefill.autoPayPlan-review');
              }
            },
            function (reason) {
              $scope.prepaidRefillAutoPayPlanError = true;
            }
          );
        },
        setAmount: function () {
          $scope.gst = prepaidRefillTaxCalculationService.getGST();
          $scope.pst = prepaidRefillTaxCalculationService.getPST();
          $scope.totalAmount = prepaidRefillTaxCalculationService.getTotal();
          $scope.refillAmount = prepaidPlanInfoService.getAirTimePlanFee();
        },
        retrieveCreditCardRegistrationInfo: function (accountNumber, subscriberNumber) {
          var promise = httpService.send(
            'v1/wireless/prepaid/creditcard/retrieve/ccinfo', // TODO : Need to change
            {
              accountNumber: accountNumber,
              ctn: subscriberNumber
            });

          promise.then(
            function (result) {
              if (result.data.error || result.data.status == 'Failed') {
                $scope.creditCardRegistrationInfoError = true;
              } else {
                //alert('Got userInfo Successfully');
                $scope.creditCardRegistrationInfo = result.data;
                if ($scope.creditCardRegistrationInfo.registrationStatus) {
                  //prepaidRegisteredCCInfoService.setCardScheme($scope.creditCardRegistrationInfo.creditCardInfo.cardType);
                  prepaidRegisteredCCInfoService.setTokenizedCCNumber($scope.creditCardRegistrationInfo.creditCardInfo.creditCardNo);
                  prepaidRegisteredCCInfoService.setMonth($scope.creditCardRegistrationInfo.creditCardInfo.expiryDate);
                  prepaidRegisteredCCInfoService.setYear($scope.creditCardRegistrationInfo.creditCardInfo.expiryDate);
                }
                prepaidRegisteredCCInfoService.setCreditCardRegistrationStatus($scope.creditCardRegistrationInfo.registrationStatus);
              }
            },
            function (reason) {
              $scope.creditCardRegistrationInfoError = true;
            }
          );
        },

        stopAutoPayPlanPayment: function () {
          /*var modalConfig = {
           templateUrl: 'modules/my-account/prepaid/dashboard/refill/stop-auto-payments.html',
           controller: function ($scope, $modalInstance) {
           $scope.ok = function () {
           $modalInstance.close();
           };
           $scope.cancel = function () {
           $modalInstance.dismiss('cancel');
           };
           },
           ok: function () {
           var promise = httpService.send('v1/refill/autorefill/stop/autopayment',
           {
           accountNumber: prepaidUserInfoService.getBAN(),
           ctn :  prepaidUserInfoService.getCTN(),
           cancelExLBStatus : false,
           cancelMsfStatus : true
           });
           promise.then(
           function (choice) {
           if (choice.data.error || choice.data.status == 'Failed') {
           $scope.stopAutoPaymentError = true;
           } else {
           $scope.updateRefillBalanceService();
           }
           },
           function (reason) {
           prepaidAutoRefillInfoService.setStopAutoPaymentResponse(false);
           $scope.stopAutoPaymentError = true;
           $state.go('myAccount.prepaidRefill');
           }
           );
           },
           cancel: function () {

           }
           };*/
          // show modal
          //uteModal.open(modalConfig);
          uteModal.open({
            templateUrl: 'modules/my-account/prepaid/dashboard/refill/stop-auto-payments.html',
            /*controller: function ($scope, $modalInstance) {
             $scope.ok = function () {
             $modalInstance.close();
             };
             $scope.cancel = function () {
             $modalInstance.dismiss('cancel');
             };
             },*/
            ok: function () {
              var promise = httpService.send('v1/refill/autorefill/stop/autopayment',
                {
                  accountNumber: prepaidUserInfoService.getBAN(),
                  ctn: prepaidUserInfoService.getCTN(),
                  cancelExLBStatus: false,
                  cancelMsfStatus: true
                });
              promise.then(
                function (choice) {
                  if (choice.data.error || choice.data.status == 'Failed') {
                    $scope.stopAutoPaymentError = true;
                  } else {
                    $scope.updateRefillBalanceService();
                  }
                },
                function (reason) {
                  prepaidAutoRefillInfoService.setStopAutoPaymentResponse(false);
                  $scope.stopAutoPaymentError = true;
                  $state.go('myAccount.prepaidRefill');
                }
              );
            },
            cancel: function () {

            }
          });
        }
      });
      /**
       *
       * @param state
       */
      $scope.go = function (state) {
        $state.go(state);
      };

      $scope.today = new Date();
      $scope.firstMonth = 1;
      $scope.setRange = function (min, max) {
        var months = [];
        for (var i = min; i <= max; i++) months.push(i);
        return months;
      };
      $scope.payNowRule = {
        amount: {
          type: 'number',
          min: 0.01
        },
        ccNumber: {
          pattern: '((([0-9]{4}[ -]?){4})|(([0-9]{4}[ -]?)([0-9]{6}[ -]?)([0-9]{5})))'
        },
        expMonth: {
          type: 'number',
          min: 1,
          max: 12
        },
        expYear: {
          type: 'number',
          min: 2015,
          max: 2025
        },
        cvv: {
          type: 'text',
          minlength: 3,
          maxlength: 4,
          pattern: '^[0-9]{3,4}$'
        },
        ccName: {
          pattern: 'VISA|MASTER|AMEX'
        },
        ccTnc: {}
      };

      $scope.payNow = {};
      $scope.payment = {};
      var selfCardType = '';

      $scope.registerCreditCard = function (form) {
        util.validateFormOnSubmit(form);
        if (!form.$valid || ($scope.payNow.expYear == $scope.today.getFullYear() && $scope.payNow.expMonth <= $scope.today.getMonth())) {
          if (uteSemafoneService.getMaskedCardNumber() == null || uteSemafoneService.getMaskedCardNumber() == '') {
            $scope.isNotValidCard = true;
          }
          return;
        }

        if (uteSemafoneService.getCardScheme() == 'VISA') {
          selfCardType = 'VISA';
        } else if (uteSemafoneService.getCardScheme() == 'AMEX') {
          selfCardType = 'AMEX';
        } else if (uteSemafoneService.getCardScheme() == 'MASTERCARD') {
          selfCardType = 'MASTERCARD';
        }

        var cvvLength = document.getElementById('cvv').value.length;
        $scope.maskedCardNumber = uteSemafoneService.getMaskedCardNumber();
        $scope.payment.maskedToken = uteSemafoneService.getToken();
        $scope.payment.ccType = uteSemafoneService.getCardScheme();

        if ($scope.payment.ccType == 'VISA') {
          $scope.cardType = 'ute-creditcards visa';
        }
        if ($scope.payment.ccType == 'AMEX') {
          $scope.cardType = 'ute-creditcards amex';
        }
        if ($scope.payment.ccType == 'MASTERCARD') {
          $scope.cardType = 'ute-creditcards master';
        }

        if ($scope.payment.maskedToken == null || $scope.payment.maskedToken == '') {
          $scope.isNotValidCard = true;
          alert('The card number is invalid');
        } else {
          console.log('$scope.payment ready', $scope.payment);
        }

        var promise = httpService.send(
          'v1/wireless/prepaid/creditcard/register', {
            'CreditCardInfo.ccType': $scope.payment.ccType,
            'CreditCardInfo.ccNumber': $scope.payment.maskedToken,
            'CreditCardInfo.ccExpiryMonth': $scope.payNow.expMonth,
            'CreditCardInfo.ccExpiryYear': $scope.payNow.expYear,
            'CreditCardInfo.securityCode': $scope.payNow.cvv,
            ctn: prepaidUserInfoService.getCTN(),
            accountNumber: prepaidUserInfoService.getBAN()
          });

        promise.then(
          function (result) {
            if (result.data.error || result.data.status == 'Failed') {
              $scope.registerCardInfoError = true;
            } else {
              /*prepaidRegisteredCCInfoService.setCreditCardRegistrationStatus(true);
               prepaidRegisteredCCInfoService.setMonth($scope.payNow.expMonth + '-' + $scope.payNow.expYear);
               prepaidRegisteredCCInfoService.setTokenizedCCNumber($scope.payment.maskedToken);*/
              $scope.retrieveCreditCardRegistrationInfo(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN());
              $scope.continueButton();
            }
          },
          function (reason) {
            $scope.registerCardInfoError = true;
          }
        );
      };

      /**
       * tabs data for ui tabs directive
       * @type {{heading: string, subheading: string, route: string}[]}
       */

      $scope.tabData = [
        {
          heading: 'wireless.label.setUpAutoPayPlan',
          route: 'myAccount.prepaidRefill.autoPayPlan',
          autoRefillSubscribed: 'true',
          content: prepaidAutoRefillInfoService.getAutoPayPlanSubContent(),
          class: prepaidAutoRefillInfoService.getAutoPayPlanContentClass(),
          active: true
        },
        {
          heading: 'wireless.label.setUpAutoRefillBalance',
          route: 'myAccount.prepaidRefill.autoRefillBalance',
          autoRefillSubscribed: 'false',
          content: prepaidAutoRefillInfoService.getAutoRefillBalanceSubContent(),
          class: 'tab pp-refill-margin-top-1-5',
        },
        {
          heading: 'wireless.label.oneTimeRefill',
          route: 'myAccount.prepaidRefill.oneTimeRefill',
          class: 'tab pp-refill-margin-top-1-5',

        },
        {
          heading: 'wireless.label.redeemVoucher',
          route: 'myAccount.prepaidRefill.redeemVoucher',
          class: 'tab pp-refill-margin-top-1-5',
        }
      ];

      $scope.mobileTabData = [
        {
          heading: 'wireless.label.setUpAutoPayPlan',
          route: 'myAccount.prepaidRefill.autoPayPlan',
          autoRefillSubscribed: 'true',
          content: prepaidAutoRefillInfoService.getAutoPayPlanSubContent(),
          class: 'tab pp-refill-margin-top-1-5',
          active: true
        }
      ];

      $scope.init();
      $scope.setAmount();
      $scope.getAddonListInfo(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN(), $scope.language);

    }]);

})();


